module.exports = __webpack_public_path__ + "media/images/icons/trash-8b0a774b18795037e69a47b620bdf6ec.svg";